<template>
    <div>
        
        <section>
            <!-- Navigation Header -->
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img :src="require('@/assets/images/NewSelf_Logo.png')" 
                             sizes="(max-width: 479px) 100vw, 84.03125px"
                             loading="lazy" 
                             class="image-294">
                    </a>
                    <div class="form-nav-div">
                        <a href="#" @click.prevent="questionId > 1 ? questionId-- : null" class="back-link w-inline-block">
                            <div class="text-block-507">&lt;-</div>
                        </a>
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Step <strong>{{ questionId }}</strong> of <strong>{{ 10 }}</strong></div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / 10) * 100) }}%</strong> Complete</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                        <div class="text-block-505"></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-7">
            <div class="questions-div">
                <!-- Sex at Birth -->
                <div class="question-container" v-if="questionId === 1">
                    <div class="question-div-2">
                        <div class="text-block-513">What was your sex assigned at birth?</div>
                        <div class="felix-form-block w-form">
                            <div class="felix-form-block w-form">
                            <a href="#" @click.prevent="setSex('Female')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d8197d38318417c44d9c4_Female.svg"
                                        class="image-307" loading="lazy">
                                    <div class="text-block-545">Female</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="setSex('Male')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d81974f75b229e7b38302_Male.svg"
                                        class="image-307" loading="lazy">
                                    <div class="text-block-545">Male</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </div>
                        </div>
                    </div>
                </div>

                <!-- Pregnancy Question (Conditional) -->
                <div class="question-container" v-if="questionId === 2 && patient.sex === 'Female'">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you currently pregnant, breastfeeding or planning to become pregnant?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="setPregnancyStatus('Yes')" class="button-68 w-button">YES</a>
                                <a href="#" @click.prevent="setPregnancyStatus('No')" class="button-68 w-button">NO</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Height and Weight -->
                <div class="question-container" v-if="questionId === 3">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your height and weight?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateHeightWeight">
                                <div class="div-block-1478 mobile-entry form _2 height top">
                                    <input class="text-field-44 height w-input" maxlength="2" v-model="patient.height.feet" placeholder="Feet" type="number" required>
                                    <input class="text-field-44 height w-input" maxlength="2" v-model="patient.height.inches" placeholder="Inches" type="number" required>
                                </div>
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input class="text-field-45 weight w-input" maxlength="3" v-model="patient.weight" placeholder="Weight in pounds" type="number" required>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Primary Goals -->
                <div class="question-container" v-if="questionId === 4">
                    <div class="question-div-2">
                        <div class="text-block-513">What are your primary goals for Vitamin B12 supplementation?</div>
                        <div class="form-subs">Select all that apply</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="checkbox-options">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="goal in supplementationGoals" :key="goal.id">
                                    <input type="checkbox" name="checkbox-3" id="checkbox-3" v-model="patient.goals" :value="goal.id"  class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3">{{ goal.label }}</span>
                                </label>
                                </div>
                                <div class="form-group" v-if="patient.goals.includes('other')">
                                    <textarea 
                                        v-model="patient.otherGoal" 
                                        class="textarea w-input" 
                                        placeholder="Please specify other goal" 
                                        required></textarea>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Diet Habits -->
                <div class="question-container" v-if="questionId === 5">
                    <div class="question-div-2">
                        <div class="text-block-513">How often do you consume animal products (meat, fish, dairy)?</div>
                        <div class="felix-form-block w-form">
                            <form>
                                <a href="#"  class="link-block-30 w-inline-block"  v-for="option in dietaryOptions" :key="option.id" @click.prevent="setdietaryHabits(option.label)">
                                    <div>
                                        <div class="text-block-545">{{option.label}}</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Symptoms -->
                <div class="question-container" v-if="questionId === 6">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you experience any of the following symptoms?</div>
                        <div class="form-subs">Select all symptoms that apply to you</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="checkbox-options">
                                    <label v-for="symptom in b12Symptoms" :key="symptom.id" class="w-checkbox checkbox-field-15 w-clearfix">
                                        <input type="checkbox" 
                                               v-model="patient.symptoms" 
                                               :value="symptom.id" 
                                               class="w-checkbox-input checkbox-11">
                                        <span class="checkbox-label-12 w-form-label">{{ symptom.label }}</span>
                                    </label>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Medical History -->
                <div class="question-container" v-if="Math.floor(questionId) === 7 && !showingConditionDetails">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have a history of any of the following conditions?</div>
                        <div class="form-subs">Check all that apply</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateMedicalHistory">
                                <div class="checkbox-options">
                                    <label v-for="condition in medicalConditions" :key="condition.id" class="w-checkbox checkbox-field-15 w-clearfix">
                                        <input type="checkbox" 
                                               v-model="patient.medicalHistory" 
                                               :value="condition.id" 
                                               class="w-checkbox-input checkbox-11"
                                               :disabled="condition.id !== 'none' && patient.medicalHistory.includes('none')">
                                        <span class="checkbox-label-12 w-form-label">{{ condition.label }}</span>
                                    </label>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Medical Condition Details -->
                <div class="question-container" v-if="Math.floor(questionId) === 7 && showingConditionDetails">
                    <div class="question-div-2">
                        <div class="text-block-513">{{ currentConditionTitle }}</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="submitConditionDetails">
                                <div v-for="(question, index) in currentConditionQuestions" :key="index" class="condition-question mb-4">
                                    <label class="question-label mb-2 block">{{ question }}</label>
                                    <textarea 
                                        v-model="currentConditionAnswers[index]"
                                        class="textarea w-input"
                                        rows="3"
                                        required
                                    ></textarea>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Current Medications -->
                <div class="question-container" v-if="questionId === 8">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you currently taking any medications or supplements?</div>
                        <div class="form-subs">Check all that apply</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateMedications">
                                <div class="checkbox-options">
                                    <label v-for="med in medications" :key="med.id" class="w-checkbox checkbox-field-15 w-clearfix">
                                        <input type="checkbox" 
                                               v-model="patient.currentMedications" 
                                               :value="med.label" 
                                               class="w-checkbox-input checkbox-11">
                                        <span class="checkbox-label-12 w-form-label">{{ med.label }}</span>
                                    </label>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Current Medications -->
                <div class="question-container" v-if="questionId === 9">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you experience any of the following symptoms that may indicate neurological or hematological issues?</div>
                        <div class="form-subs">Check all that apply.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateMedications">
                                <div class="checkbox-options">
                                    <label v-for="med in hematologicalOptions" :key="med.id" class="w-checkbox checkbox-field-15 w-clearfix">
                                        <input type="checkbox" 
                                               v-model="patient.hematologicalIssues" 
                                               :value="med.label" 
                                               class="w-checkbox-input checkbox-11">
                                        <span class="checkbox-label-12 w-form-label">{{ med.label }}</span>
                                    </label>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Informed Consent -->
                <div class="question-container" v-if="questionId === 10">
                    <div class="question-div-2">
                        <div class="text-block-513">Informed Consent for Vitamin B12 Supplementation</div>
                        <div class="consent-text" v-html="consentText"></div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="submitForm">
                                <div class="consent-options">
                                    <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" v-model="patient.consent" class="w-checkbox-input checkbox-11" required>
                                    <span class="checkbox-label-12 w-form-label">I have read and understand the informed consent statement</span>
                                    </label>
                                    
                                </div>
                                <button type="submit" class="form-button w-button" :disabled="loading">
                                    {{ loading ? 'Submitting...' : 'Complete Screening' }}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div style="height: 320px;"></div>
    </div>
</template>

<script>
export default {
    name: 'VitaminB12Form',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questionId: 1,
            loading: false,
            showingConditionDetails: false,
            currentConditionIndex: 0,
            currentConditionAnswers: [],
            patient: {
                sex: '',
                pregnancyStatus: null,
                height: {
                    feet: '',
                    inches: ''
                },
                weight: '',
                goals: [],
                otherGoal: '',
                dietaryHabits: '',
                symptoms: [],
                medicalHistory: [],
                medicalDetails: {},
                currentMedications: [],
                hematologicalIssues:[],
                otherMedications: '',
                consent: null
            },
            hematologicalOptions:[
                { id: 'Numbness', label: 'Numbness or tingling in the extremities' },
                { id: 'Balance', label: 'Balance problems or difficulty walking' },
                { id: 'Cognitive', label: 'Cognitive or memory issues' },
                { id: 'pale', label: 'Pale or jaundiced skin' },
                { id: 'none', label: 'None of the above' }
            ],
            supplementationGoals: [
                { id: 'energy', label: 'Increase energy levels' },
                { id: 'cognitive', label: 'Improve cognitive function' },
                { id: 'mood', label: 'Enhance mood' },
                { id: 'deficiency', label: 'Address Vitamin B12 deficiency symptoms' },
                { id: 'nerve', label: 'Support nerve health' },
                { id: 'bloodCells', label: 'Improve red blood cell production' },
                { id: 'other', label: 'Other' }
            ],
            dietaryOptions: [
                { id: 'daily', label: 'Daily' },
                { id: 'several', label: 'Several times a week' },
                { id: 'once', label: 'Once a week' },
                { id: 'never', label: 'Rarely or never' }
            ],
            b12Symptoms: [
                { id: 'fatigue', label: 'Fatigue or weakness' },
                { id: 'numbness', label: 'Numbness or tingling in the hands or feet' },
                { id: 'balance', label: 'Difficulty walking or balance problems' },
                { id: 'cognitive', label: 'Cognitive issues (e.g., memory problems, confusion)' },
                { id: 'skin', label: 'Pale or jaundiced skin' },
                { id: 'breathing', label: 'Shortness of breath or dizziness' },
                { id: 'none', label: 'None of the above' }
            ],
            medicalConditions: [
                { 
                    id: 'pernicious', 
                    label: 'Pernicious anemia',
                    questions: [
                        'When were you diagnosed with pernicious anemia?',
                        'Are you currently receiving treatment for pernicious anemia?',
                        'Please describe any symptoms you experience related to pernicious anemia:'
                    ]
                },
                { 
                    id: 'gastrointestinal', 
                    label: 'Gastrointestinal issues (e.g., Crohn\'s disease, celiac disease)',
                    questions: [
                        'What specific gastrointestinal condition(s) have you been diagnosed with?',
                        'When were you diagnosed?',
                        'What treatments are you currently receiving for this condition?'
                    ]
                },
                { 
                    id: 'surgery', 
                    label: 'Stomach or intestinal surgery (e.g., gastric bypass)',
                    questions: [
                        'What type of surgery did you undergo?',
                        'When was the surgery performed?',
                        'Have you experienced any complications since the surgery?'
                    ]
                },
                { 
                    id: 'diet', 
                    label: 'Vegan or vegetarian diet',
                    questions: [
                        'How long have you been following this diet?',
                        'What type of diet do you follow (vegan, vegetarian, pescatarian, etc.)?',
                        'Do you take any supplements to support your dietary choices?'
                    ]
                },
                { 
                    id: 'alcohol', 
                    label: 'Alcohol use disorder',
                    questions: [
                        'Are you currently receiving treatment for alcohol use disorder?',
                        'When was your last alcohol consumption?',
                        'Have you experienced any health complications related to alcohol use?'
                    ]
                },
                { id: 'none', label: 'None of the above' }
            ],
            medications: [
                { id: 'ppi', label: 'Proton pump inhibitors (e.g., omeprazole, pantoprazole)' },
                { id: 'metformin', label: 'Metformin' },
                { id: 'b12', label: 'Vitamin B12 supplements (oral or injectable)' },
                { id: 'multivitamin', label: 'Multivitamins or B-complex vitamins' },
                { id: 'none', label: 'None of the above' }
            ],
            consentText: `
                <div class="consent-content">
                    <p>Vitamin B12 (cobalamin) is an essential vitamin that plays a critical role in red blood cell production, neurological function, and DNA synthesis. It is commonly found in animal products, and a deficiency can occur in individuals with limited dietary intake, certain medical conditions, or due to medication use.</p>
                    
                    <h4>Potential Benefits:</h4>
                    <ul>
                        <li>Increased energy levels</li>
                        <li>Improved neurological function</li>
                        <li>Enhanced cognitive function</li>
                        <li>Better nerve health</li>
                        <li>Improved red blood cell production</li>
                    </ul>

                    <h4>Possible Risks and Side Effects:</h4>
                    <ul>
                        <li>Mild diarrhea</li>
                        <li>Skin rash or itching</li>
                        <li>Headache</li>
                        <li>Nausea or vomiting</li>
                        <li>Rare but serious allergic reactions</li>
                        <li>Potential hypokalemia in severe deficiency cases</li>
                    </ul>

                    <p>By proceeding, you acknowledge that you understand these risks and benefits, and agree to follow the prescribed treatment plan and monitoring requirements.</p>
                </div>
            `
        }
    },
    computed: {
        currentCondition() {
            const selectedConditions = this.patient.medicalHistory.filter(id => id !== 'none');
            return selectedConditions[this.currentConditionIndex];
        },
        currentConditionTitle() {
            if (!this.currentCondition) return '';
            const condition = this.medicalConditions.find(c => c.id === this.currentCondition);
            return `Tell us more about your ${condition.label}`;
        },
        currentConditionQuestions() {
            if (!this.currentCondition) return [];
            const condition = this.medicalConditions.find(c => c.id === this.currentCondition);
            return condition ? condition.questions : [];
        },
        actualTotalQuestions() {
            const selectedConditions = this.patient.medicalHistory.filter(id => id !== 'none');
            const additionalSteps = selectedConditions.length;
            return 9 + additionalSteps;
        },
        displayStepNumber() {
            let step = Math.floor(this.questionId);
            if (this.showingConditionDetails) {
                step += this.currentConditionIndex;
            }
            return step;
        },
        formProgress() {
            return Math.round((this.displayStepNumber / this.actualTotalQuestions) * 100);
        }
    },
    methods: {
        setSexOnUser(){
            let temp = this.$store.getters.user;
            try{
                this.formData.weight = temp.weight;
                const totalInches = parseInt(temp.height_inch) || 0
                this.formData.height.feet = Math.floor(totalInches / 12)
                this.formData.height.inches = totalInches % 12
            }catch(error){
                console.log("unable to set height and weight")
            }

            if(temp.gender!=null || temp.gender!==''){
                this.setSex(temp.gender);
            }
        },
        setdietaryHabits(value) {
            this.patient.dietaryHabits = value;
            this.nextQuestion();
        },
        setSex(sex) {
            this.patient.sex = sex;
            if (sex === 'Male') {
                this.questionId = 3; // Skip pregnancy question
            } else {
                this.nextQuestion();
            }
        },
        setPregnancyStatus(status) {
            this.patient.pregnancyStatus = status;
            if (status === 'Yes') {
                this.disqualifyPatient();
            } else {
                this.nextQuestion();
            }
        },
        nextQuestion() {
            this.questionId++;
            this.scrollToTop();
        },
        validateHeightWeight() {
            const height = {
                feet: parseInt(this.patient.height.feet),
                inches: parseInt(this.patient.height.inches)
            };
            const weight = parseInt(this.patient.weight);

            if (isNaN(height.feet) || isNaN(height.inches) || isNaN(weight) ||
                height.feet < 3 || height.feet > 8 ||
                height.inches < 0 || height.inches > 11 ||
                weight < 50 || weight > 500) {
                alert('Please enter valid height and weight measurements');
                return;
            }
            this.nextQuestion();
        },
        validateMedicalHistory() {
            if (this.patient.medicalHistory.includes('none') || this.patient.medicalHistory.length === 0) {
                this.questionId = 8;
                return;
            }

            // Initialize medical details object
            this.patient.medicalDetails = {};
            this.patient.medicalHistory.forEach(conditionId => {
                if (conditionId !== 'none') {
                    this.patient.medicalDetails[conditionId] = {
                        answers: []
                    };
                }
            });

            // Start condition-specific questions
            this.currentConditionIndex = 0;
            this.showingConditionDetails = true;
            this.currentConditionAnswers = new Array(this.currentConditionQuestions.length).fill('');
        },
        submitConditionDetails() {
            // Save current condition answers
            this.patient.medicalDetails[this.currentCondition] = {
                answers: [...this.currentConditionAnswers]
            };

            // Check if there are more conditions to ask about
            const selectedConditions = this.patient.medicalHistory.filter(id => id !== 'none');
            if (this.currentConditionIndex < selectedConditions.length - 1) {
                // Move to next condition
                this.currentConditionIndex++;
                this.currentConditionAnswers = new Array(this.currentConditionQuestions.length).fill('');
            } else {
                // All conditions are done, move to next question
                this.showingConditionDetails = false;
                this.questionId = 8;
            }
        },
        validateMedications() {
            // Logic to check for contraindicated medications
            const contraindicatedMeds = []; // Add any contraindicated medications here
            const hasContraindicated = this.patient.currentMedications.some(med => 
                contraindicatedMeds.includes(med)
            );
            
            if (hasContraindicated) {
                this.disqualifyPatient();
            } else {
                this.nextQuestion();
            }
        },
        disqualifyPatient() {
            // Navigate to disqualification page
            this.$router.push('/sorry')
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        async submitForm() {
            if (this.patient.consent === 'decline') {
                this.$router.push({ name: 'declined' });
                return;
            }

            this.loading = true;
            try {
                const formattedData = {
                    formObj: {
                        consentsSigned: this.patient.consent,

                        // Format Q&A pairs with full questions and available options
                        Q1: "What was your sex assigned at birth? Available Options: Male, Female",
                        A1: this.patient.sex,

                        Q2: "Are you currently pregnant, breastfeeding or planning to become pregnant? Available Options: Yes, No",
                        A2: this.patient.sex === 'Female' ? this.patient.pregnancyStatus : 'N/A',

                        Q3: "What is your height and weight?",
                        A3: `Height: ${this.patient.height.feet}'${this.patient.height.inches}", Weight: ${this.patient.weight} lbs`,

                        Q4: `What are your primary goals for Vitamin B12 supplementation? Available Options: ${this.supplementationGoals.map(goal => goal.label).join(', ')}`,
                        A4: this.formatGoals(),

                        Q5: `How often do you consume animal products (meat, fish, dairy)? Available Options: ${this.dietaryOptions.map(opt => opt.label).join(', ')}`,
                        A5: this.patient.dietaryHabits,

                        Q6: `Do you experience any of the following symptoms? Available Options: ${this.b12Symptoms.map(s => s.label).join(', ')}`,
                        A6: this.formatArrayResponse(this.patient.symptoms, this.b12Symptoms),

                        Q7: `Do you have a history of any of the following conditions? Available Options: ${this.medicalConditions.map(c => c.label).join(', ')}`,
                        A7: this.formatMedicalHistory(),

                        Q8: `Are you currently taking any medications or supplements? Available Options: ${this.medications.map(m => m.label).join(', ')}`,
                        A8: this.formatArrayResponse(this.patient.currentMedications, this.medications),

                        Q9: `Do you experience any of the following symptoms that may indicate neurological or hematological issues? Available Options: ${this.hematologicalOptions.map(h => h.label).join(', ')}`,
                        A9: this.formatArrayResponse(this.patient.hematologicalIssues, this.hematologicalOptions),

                        Q10: "Informed Consent for Vitamin B12 Supplementation",
                        A10: this.patient.consent ? "Patient has acknowledged and consented" : "Consent not provided"
                    },
                    patientInfo: {
                        sex: this.patient.sex,
                        height: `${this.patient.height.feet}'${this.patient.height.inches}"`,
                        weight: `${this.patient.weight} lbs`,
                        dietaryHabits: this.patient.dietaryHabits,
                        medicalHistory: this.patient.medicalDetails,
                        submissionDate: new Date().toISOString()
                    },
                    pharmacyId: "",
                    masterId: `visit_${Date.now()}`,
                    company: "newSelf",
                    visitType: "vitamin-b12"
                };

                const response = await this.$axios.post(
                    `${this.baseUrl}/forms/assessment-form/vitamin-b12/${this.$route.params.id}`, 
                    formattedData
                );

                if (response.data.status === 'success') {
                    this.$router.push('/success');
                } else {
                    throw new Error('Form submission failed');
                }
            } catch (error) {
                console.error('Form submission error:', error);
                alert('There was an error submitting your form. Please try again.');
            } finally {
                this.loading = false;
            }
        },

        // Helper methods for formatting responses
        formatGoals() {
            if (!this.patient.goals || this.patient.goals.length === 0) {
                return "No goals selected";
            }

            return this.patient.goals.map(goalId => {
                if (goalId === 'other') {
                    return `Other: ${this.patient.otherGoal}`;
                }
                const goal = this.supplementationGoals.find(g => g.id === goalId);
                return goal?.label;
            }).filter(Boolean).join('; ');
        },

        formatArrayResponse(selectedItems, optionsArray) {
            if (!selectedItems || selectedItems.length === 0) {
                return "None selected";
            }

            return selectedItems.map(item => {
                const option = optionsArray.find(opt => opt.id === item || opt.label === item);
                return option?.label;
            }).filter(Boolean).join('; ');
        },

        formatMedicalHistory() {
            if (!this.patient.medicalHistory || this.patient.medicalHistory.length === 0) {
                return "None reported";
            }

            return this.patient.medicalHistory.map(conditionId => {
                const condition = this.medicalConditions.find(c => c.id === conditionId);
                if (!condition) return null;

                const details = this.patient.medicalDetails[conditionId];
                if (details && details.answers) {
                    return `${condition.label}:\n${condition.questions.map((q, i) => 
                        `${q} ${details.answers[i]}`
                    ).join('\n')}`;
                }
                return condition.label;
            }).filter(Boolean).join('\n\n');
        }
    },
    watch: {
        questionId() {
            this.scrollToTop();
        }
    },
    mounted() {
        this.setSexOnUser();
        this.scrollToTop();
    }
}
</script>

<style scoped>


.consent-text {
    max-height: 400px;
    overflow-y: auto;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.consent-content {
    font-size: 14px;
    line-height: 1.6;
}

.consent-content h4 {
    margin-top: 15px;
    margin-bottom: 10px;
    color: #333;
}

.consent-content ul {
    margin-bottom: 15px;
    padding-left: 20px;
}

.checkbox-options {
    margin-bottom: 20px;
}

.checkbox-field-15 {
    margin-bottom: 10px;
    padding: 10px;
    border: 1px solid #eee;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.checkbox-field-15:hover {
    background-color: #f5f5f5;
}

textarea.w-input, textarea.w-select {
    height: auto;
    width: 100%;
    border: 1px solid #dfdfdf;
    border-radius: 9px;
    margin-top: 10px;
}


@media screen and (max-width: 480px) {
    .question-container {
        padding: 10px;
    }
    
    .consent-text {
        max-height: 300px;
    }
    
    .checkbox-field-15 {
        padding: 8px;
    }
}
</style>